import {
  assignClientToQuote,
  getClientExistingByRFC,
  getQuoteInfo,
  resendNip,
  sendToCreateBureauForm,
  sendToSubmitForm,
  sendToValidateNip,
  validateClientContactInfo,
  validateClientCurpService
} from 'src/services/bureauFormService';
import { URL_DEFAULT_REDIRECT } from 'src/utils/constants/auth';
import { SnackBarVariants } from 'src/utils/constants/common';
import { asyncActionCreator } from 'src/utils/loadingUtils';
import dayjs from 'src/utils/dayjs';
import { navigate } from 'src/utils/navigate';
import {
  removeLocalStorage,
  setLocalStorage,
  getLocalStorage
} from 'src/utils/localStorage';
import { transformFormData } from 'src/utils/constants/BureauForm';
import { jwtDecode as decode } from 'jwt-decode';
import { showMessage } from './snackBarActions';

export const VALIDATE_CLIENT_BY_RFC = asyncActionCreator(
  'VALIDATE_CLIENT_BY_RFC'
);
export const ASSOCIATE_CLIENT_TO_QUOTE = asyncActionCreator(
  'ASSOCIATE_CLIENT_TO_QUOTE'
);
export const SEND_CLIENT_TO_VALIDATION = asyncActionCreator(
  'SEND_CLIENT_TO_VALIDATION'
);
export const CREATE_BURO_FORM = asyncActionCreator('CREATE_BURO_FORM');
export const CREATE_LEGAL_PERSON_BURO_FORM = asyncActionCreator(
  'CREATE_LEGAL_PERSON_BURO_FORM'
);
export const RESEND_NIP = asyncActionCreator('RESEND_NIP');
export const GET_QUOTE_INFORMATION = asyncActionCreator(
  'GET_QUOTE_INFORMATION'
);
export const VALIDATE_CLIENT_CONTACT_INFO = asyncActionCreator(
  'VALIDATE_CLIENT_CONTACT_INFO'
);
export const VALIDATE_CLIENT_CURP = asyncActionCreator('VALIDATE_CLIENT_CURP');
export const VALIDATE_BUREAU_TOKEN = asyncActionCreator(
  'VALIDATE_BUREAU_TOKEN'
);

export const GET_TOKEN_DATA = 'GET_TOKEN_DATA';

export const CLEAR_CLIENT_VALIDATION = 'CLEAR_CLIENT_VALIDATION';
export const CLEAR_BUREAU_FORM_ID = 'CLEAR_BUREAU_FORM_ID';
export const CLEAR_TEMPORAL_TOKEN = 'CLEAR_TEMPORAL_TOKEN';

export const validateClientExistByRfc = rfc => async dispatch => {
  try {
    dispatch({
      type: VALIDATE_CLIENT_BY_RFC.start
    });

    const response = await getClientExistingByRFC(rfc);
    dispatch({
      type: VALIDATE_CLIENT_BY_RFC.success,
      payload: response
    });
  } catch (error) {
    dispatch(
      showMessage({
        message: error.message,
        variant: SnackBarVariants.ERROR
      })
    );
    dispatch({ type: VALIDATE_CLIENT_BY_RFC.failure });
  }
};

export const getQuoteInformation = () => async dispatch => {
  try {
    dispatch({
      type: GET_QUOTE_INFORMATION.start
    });
    const response = await getQuoteInfo();
    dispatch({
      type: GET_QUOTE_INFORMATION.success,
      payload: response
    });
  } catch (error) {
    dispatch(
      showMessage({
        message: error.message,
        variant: SnackBarVariants.ERROR
      })
    );
    dispatch({ type: GET_QUOTE_INFORMATION.failure });
  }
};

export const associateClientToQuote = (
  clientId,
  onCloseDialog
) => async dispatch => {
  try {
    dispatch({
      type: ASSOCIATE_CLIENT_TO_QUOTE.start
    });
    await assignClientToQuote(clientId);
    dispatch({
      type: ASSOCIATE_CLIENT_TO_QUOTE.success
    });
    onCloseDialog();
    return window.location.replace(URL_DEFAULT_REDIRECT);
  } catch (error) {
    dispatch(
      showMessage({
        message: error.message,
        variant: SnackBarVariants.ERROR
      })
    );
    return dispatch({ type: ASSOCIATE_CLIENT_TO_QUOTE.failure });
  }
};

export const decodeTokenForBureauForm = token => async dispatch => {
  const redirect = () => {
    setTimeout(() => {
      const redirectUrl =
        process.env.REACT_APP_URL_DEFAULT_REDIRECT || 'https://astrocap.com/';
      return window.location.replace(redirectUrl);
    }, 5000);
  };

  try {
    const existingToken = getLocalStorage('temporalToken');
    if (existingToken) {
      removeLocalStorage('temporalToken');
    }

    const decodeToken = decode(token);

    if (dayjs.tz().isAfter(dayjs.unix(decodeToken.exp))) {
      dispatch({ type: VALIDATE_BUREAU_TOKEN.failure });

      dispatch(
        showMessage({
          message: 'ERRORS.EXPIRED_TOKEN',
          variant: SnackBarVariants.ERROR
        })
      );

      setTimeout(() => {
        redirect();
      }, 500);
      return;
    }

    dispatch({ type: VALIDATE_BUREAU_TOKEN.start });

    setLocalStorage('temporalToken', token);
    dispatch({
      type: GET_TOKEN_DATA,
      payload: decodeToken
    });

    try {
      const response = await getQuoteInfo();
      dispatch({
        type: GET_QUOTE_INFORMATION.success,
        payload: response
      });
      dispatch({ type: VALIDATE_BUREAU_TOKEN.success });
    } catch (validationError) {
      if (validationError.message.includes('401')) {
        removeLocalStorage('temporalToken');
        dispatch({ type: VALIDATE_BUREAU_TOKEN.failure });

        dispatch(
          showMessage({
            message: 'ERRORS.INVALID_TOKEN',
            variant: SnackBarVariants.ERROR
          })
        );

        // Small delay to ensure toast is displayed before redirect
        setTimeout(() => {
          redirect();
        }, 500);
      } else {
        dispatch({ type: VALIDATE_BUREAU_TOKEN.failure });
        dispatch(
          showMessage({
            message: validationError.message,
            variant: SnackBarVariants.ERROR
          })
        );
      }
    }
  } catch (error) {
    removeLocalStorage('temporalToken');
    dispatch({ type: VALIDATE_BUREAU_TOKEN.failure });

    dispatch(
      showMessage({
        message: 'ERRORS.INVALID_TOKEN',
        variant: SnackBarVariants.ERROR
      })
    );

    setTimeout(() => {
      redirect();
    }, 500);
  }
};

export const clearToken = () => async dispatch => {
  removeLocalStorage('temporalToken');
  dispatch({
    type: CLEAR_TEMPORAL_TOKEN
  });
  dispatch({
    type: VALIDATE_BUREAU_TOKEN.failure
  });
  navigate('/');
};

export const createBureauForm = (values, onNext) => async dispatch => {
  try {
    dispatch({
      type: CREATE_BURO_FORM.start
    });
    const dataTransform = transformFormData(values);
    const formId = await sendToCreateBureauForm(dataTransform);
    dispatch({
      type: CREATE_BURO_FORM.success,
      payload: formId
    });
    onNext(values);
  } catch (error) {
    dispatch(
      showMessage({
        message: error.message,
        variant: SnackBarVariants.ERROR
      })
    );
    dispatch({ type: CREATE_BURO_FORM.failure });
  }
};

export const clearBureauFormId = () => async dispatch => {
  dispatch({
    type: CLEAR_BUREAU_FORM_ID
  });
};

export const resendNipCode = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: RESEND_NIP.start
    });
    const { formId } = getState().bureauForm;
    if (!formId) {
      dispatch(
        showMessage({
          message: 'NO_FORM_ID',
          variant: SnackBarVariants.ERROR
        })
      );
    } else {
      await resendNip(formId);
    }
    dispatch({
      type: RESEND_NIP.success
    });
  } catch (error) {
    dispatch(
      showMessage({
        message: error.message,
        variant: SnackBarVariants.ERROR
      })
    );
    dispatch({ type: RESEND_NIP.failure });
  }
};

export const submitBureauForm = (values, onNext) => async (
  dispatch,
  getState
) => {
  try {
    dispatch({
      type: SEND_CLIENT_TO_VALIDATION.start
    });

    const { bureauForm } = getState();
    const { nip } = values;
    const dataTransform = transformFormData(values);
    const validated = await sendToValidateNip({
      nip,
      formId: bureauForm.formId
    });

    if (!validated) {
      dispatch(
        showMessage({
          message: 'INVALID_NIP',
          variant: SnackBarVariants.ERROR
        })
      );
      return dispatch({ type: SEND_CLIENT_TO_VALIDATION.failure });
    }

    const result = await sendToSubmitForm({
      formId: bureauForm.formId,
      values: dataTransform
    });
    dispatch({
      type: SEND_CLIENT_TO_VALIDATION.success,
      payload: result
    });
    dispatch(
      showMessage({
        message: 'BUREAU_FORM_SEND_SUCCESS',
        variant: SnackBarVariants.SUCCESS
      })
    );
    return onNext();
  } catch (error) {
    dispatch(
      showMessage({
        message: error.message,
        variant: SnackBarVariants.ERROR
      })
    );
    return dispatch({ type: SEND_CLIENT_TO_VALIDATION.failure });
  }
};

export const validateClientContactInformation = (
  data,
  onNext
) => async dispatch => {
  try {
    dispatch({
      type: VALIDATE_CLIENT_CONTACT_INFO.start
    });
    const contactValidation = await validateClientContactInfo(data);
    dispatch({
      type: VALIDATE_CLIENT_CONTACT_INFO.success
    });
    onNext({ ...data, ...contactValidation });
  } catch (error) {
    dispatch(
      showMessage({
        message: error.message,
        variant: SnackBarVariants.ERROR
      })
    );
    dispatch({ type: VALIDATE_CLIENT_CONTACT_INFO.failure });
  }
};

export const validateClientCurp = (values, onNext) => async dispatch => {
  try {
    dispatch({
      type: VALIDATE_CLIENT_CURP.start
    });

    const response = await validateClientCurpService({ curp: values.curp });
    dispatch({
      type: VALIDATE_CLIENT_CURP.success
    });
    if (typeof onNext === 'function') {
      return onNext({ ...values, ...response });
    }
    return null;
  } catch (error) {
    dispatch(
      showMessage({
        message: error.message,
        variant: SnackBarVariants.ERROR
      })
    );
    return dispatch({ type: VALIDATE_CLIENT_CURP.failure });
  }
};
